import { createAdminResource } from 'lib/admin-kit';
import userSsoAssignmentConfig from './config';

export default createAdminResource(userSsoAssignmentConfig).Show;
